import { useTranslation } from 'react-i18next';
import styles from './NewsletterPage.module.css';
export const ETAPES = ['contenu', 'destinataires', 'apercu', 'envoi'] as const;
export type Etape = (typeof ETAPES)[number];
export function etapeDe(valeur: string | null): Etape {
  return ETAPES.find((e) => e === valeur) ?? 'contenu';
}
/** Fil des quatre étapes d'une campagne ; l'étape courante est portée par l'URL. */
export function Etapes({
  courante,
  onChoisir,
  terminees,
}: {
  courante: Etape;
  onChoisir: (e: Etape) => void;
  terminees: Partial<Record<Etape, boolean>>;
}) {
  const { t } = useTranslation('regie');
  return (
    <nav aria-label={t('newsletter.etapes.titre')}>
      <ol className={styles.etapes}>
        {ETAPES.map((e, i) => (
          <li key={e}>
            <button
              type="button"
              className={styles.etape}
              aria-current={courante === e ? 'step' : undefined}
              data-fait={terminees[e] ? 'oui' : undefined}
              onClick={() => onChoisir(e)}
            >
              <span className={styles.etapeNumero} aria-hidden="true">
                {i + 1}
              </span>
              <span className={styles.etapeLibelle}>{t(`newsletter.etapes.${e}`)}</span>
            </button>
          </li>
        ))}
      </ol>
    </nav>
  );
}
